<template>
  <div>
    <div class="af" v-if="samePost && samePost.length > 0">
      <span style="font-size: 15px;color: #00428B;font-weight: bold;">你可能感兴趣 ：</span>
      <router-link 
        :to="{ path: '/thread-' + i.id + '-1.html' }" 
        v-for="i in samePost" 
        :key="i.id" 
        style="font-size: 16px;display: block; color: #303133;margin-top: 4px;font-weight: normal;"> 
        <!-- <el-tag v-if="i.tags && i.tags.length > 0" type="primary" :key="i" class="product-tag">{{ i.tags[0] }}</el-tag> -->
        <span v-if="i.tags && i.tags.length > 0" style="color: #00428B;">{{ i.tags[0] }} : </span>
        {{ i.title }}
      </router-link>
    </div>
    <div class="ad">
      <a :href=" 'https://www.wch.cn/products/' + post.alias + '.html?from=signature_ad'" style="display: block;">热门产品 : {{ post.shortTitle }}</a>
    </div>
  </div>
</template>

<script>
import { getAd,getSameTagPost } from "@/service/post";

export default {
  props: {
    postId: {
      required: false,
    },
    tags: {
      required: false,
      type: Array,
      // 数组默认值需用函数返回
      default: () => [] 
    }
  },

  // 1. 初始打印

  data() {
    return {
      post: null,
      samePost: [],
      commonElements: []
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      // 热门产品
      getAd()
        .then((response) => {
          console.debug("response", response);
          if (response.code === 0) {
            this.post = response.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
        // 获取同Tag下的文章(随机3篇) TODO 这里怎么取到原来的post_id
      getSameTagPost({postId: this.postId})
        .then((response) => {
          if (response.code === 0) {
            this.samePost = response.data;
            this.samePost.forEach((item, index) => {
              const splitArray = item.tag.split(',');
              if(this.isEmptyArray(splitArray) && this.isEmptyArray(this.tags)){
                this.samePost[index].tags = this.findCommonElements(this.tags,splitArray);
                console.log("==========>进入了这个方法",this.findCommonElements(this.tags,splitArray))
              }
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    findCommonElements(array1,array2) {
      // 情况1：处理简单值数组（数字/字符串）
      const simpleCommon = array1.filter(item1 => 
        array2.some(item2 => item1 === item2)
      );
      return simpleCommon;
    },
    // 封装工具函数：判断是否为非空数组
    isEmptyArray(arr) {
      // 步骤1：先判断是否为数组类型
      if (!Array.isArray(arr)) {
        return false; // 不是数组 → 返回false
      }
      // 步骤2：是数组则判断长度是否大于0（非空）
      return arr.length > 0; // 长度>0 → 返回true，否则返回false
    }
  },
};
</script>
<style lang="less" scoped>
.ad {
  margin: 20px;
  margin-top: 10px;
  padding-top: 5px;
  border-top: 1px solid #969696;
  min-height: 40px;
  height: auto !important;
  font-size: 12px;
  margin-bottom: 20px;
}

.af {
  margin: 20px;
  margin-top: 10px;
  padding-top: 5px;
  min-height: 40px;
  height: auto !important;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 20px;
}

</style>
